export default __webpack_public_path__ + "static/media/banner-1.f8527021.jpg";